import awsExports from '../aws-exports';

const environments = [
    {
        value: {
            API_KEY: process.env.REACT_APP_API_KEY,
        },
        test: env => env === 'jd-market-admin-returns-test',
    },
    {
        value: {
            API_KEY: process.env.REACT_APP_API_KEY,
        },
        test: env => env === 'jd-market-admin-returns-staging',
    },
    {
        value: {
            API_KEY: process.env.REACT_APP_API_KEY,
        },
        test: env => env === 'jd-market-admin-returns-prod',
    },
];

const bucket = awsExports.aws_content_delivery_bucket;
const env = environments.find(e => e.test(bucket));

export default env ? env.value : {};
